import "../../css/Pagination.css"
let Pagination = (props) => {
    let current = props.page
    let start = current - (current - 1) % 5

    let pageN = Math.ceil(props.listLength / props.countPerPage)
    let end = pageN === 0 ? 1 : pageN

    let onPageChange = page => {
        if (page < 1 || end < page) return
        props.setPage(page)
    }

    let nearPages = []
    for (let i = start; i < start + 5 && i <= end; i++)
        nearPages.push(i)

    return (
        <div className="pagination-container">
            <div className="pagination-info-container"></div>
            <div className="pagination-main-container">
                <div className="pagination-page" onClick={() => onPageChange(1)}>
                    <p className={"pagination-controller" + (current === 1 ? "-disabled" : "")}>{"<<"}</p>

                </div>
                <div className="pagination-page" onClick={() => onPageChange(current - 1)}>
                    <p className={"pagination-controller" + (current === 1 ? "-disabled" : "")}>{"<"}</p>
                </div>
                {nearPages.map(page => {
                    return (current === page ?
                        <div className="pagination-page pagination-current-page" onClick={() => onPageChange(page)} key={page}>{page}</div> :
                        <div className="pagination-page" onClick={() => onPageChange(page)} key={page}>{page}</div>
                    )

                })}
                <div className="pagination-page" onClick={() => onPageChange(current + 1)}>
                    <p className={"pagination-controller" + (current === end ? "-disabled" : "")}>{">"}</p>
                </div>

                <div className="pagination-page" onClick={() => onPageChange(end)}>
                    <p className={"pagination-controller" + (current === end ? "-disabled" : "")}>{">>"}</p>
                </div>
            </div>
            <div className="pagination-info-container">
                <p className="pagination-info-text">Total: {props.listLength}건</p>
                <p className="pagiantion-info-divider">|</p>
                <p className="pagination-info-text">Page: {current}/{end}</p>
            </div>
            
            </div>
    )
}

export default Pagination